<span class="ap-icon-button-link">
    <button class="ap-icon-button-link__button" (click)="onClick.emit($event)" data-testid="button">
        <asn-icon class="ap-icon-button-link__icon" [name]="iconName()" [size]="iconSize()"></asn-icon>
        <ng-content></ng-content>
    </button>
</span>
